module.exports = __webpack_public_path__ + "img/logo.63d1a19c.png";